@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container teams-container triple" [ngClass]="{ 'ht-of-single-row-options': isSingleRowOfOptions() }">
    @for (group of optionGroups | slice: 0 : visibleOptionsLimit; track trackGroup($index, group)) {
        <div class="attribute-key">
            {{ group.attribute }}
            @if (isMarketPromoted(group.optionGroupId, group.templateId)) {
                <ms-promotion-badge class="no-title" />
            }
        </div>
        @for (option of group.options; track trackOption($index, option)) {
            <ms-bet-builder-option
                [option]="option"
                [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                [optionGroup]="optionGroup"
                [event]="event"
                [showMarketAttribute]="false"
                [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                [sourceOfPick]="sourceOfPick" />
        }
    }
</div>
